/* LIT Press & Go product page: box selector, style picker, bag, shipping promise.
   Prices are enforced by Shopify automatic discounts; this file only displays the
   totals rendered by Liquid and adds the chosen boxes to the bag. */
(function () {
  var root = document.getElementById('lpp');
  if (!root) return;
  var cfg = JSON.parse(document.getElementById('lppData').textContent);
  var LOOKS = [['natural', 'Natural'], ['medium', 'Medium'], ['glam', 'Glam']];
  var LOOK_NAME = { natural: 'Natural', medium: 'Medium', glam: 'Glam' };
  var LEN_NAME = { 'short': 'Short', standard: 'Standard', 'long': 'Long' };
  var LEN_MM = { 'short': '8/10mm', standard: '10/12/14mm', 'long': '12/14/16mm' };
  var LEN_ORDER = { 'short': 0, standard: 1, 'long': 2 };
  /* Essential Upsell funnel IDs. ADDON = tweezers for 20 (the existing "Tweezer add on" funnel).
     FREE = free tweezers with 3 boxes: paste that funnel's ID here once it exists. Empty = use ADDON. */
  var ADDON_FUNNEL = 'bb32865a-3614-4472-b01e-8853e63d7b90';
  var FREE_FUNNEL = '057b12b5-7060-409b-a4e9-7957d5833858';

  /* variant id -> { style, variant } */
  var index = {};
  cfg.styles.forEach(function (s) {
    s.variants.sort(function (a, b) { return LEN_ORDER[a.len] - LEN_ORDER[b.len]; });
    s.variants.forEach(function (v) { index[v.id] = { style: s, variant: v }; });
  });
  var hasBrown = cfg.styles.some(function (s) { return s.colour === 'brown'; });

  var start = cfg.defaultVariant;
  var m = window.location.search.match(/[?&]variant=(\d+)/);
  if (m && index[parseInt(m[1], 10)] && index[parseInt(m[1], 10)].style.id === cfg.productId) start = parseInt(m[1], 10);

  var state = {
    tier: 3,
    slots: [start, start, start],
    tweezers: { 1: true, 2: true, 3: true },
    busy: false,
    tweezersInBag: false,
    boxesInBag: 0,
    pickSlot: 0,
    colour: 'black'
  };

  var $ = function (id) { return document.getElementById(id); };
  var twBox = $('lppTweezers');
  var status = $('lppStatus');
  var sheet = $('lppSheet');
  var player = $('lppPlayer');

  function esc(t) { return String(t).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function base() { return ((window.Shopify && Shopify.routes && Shopify.routes.root) || cfg.root || '/').replace(/\/?$/, '/'); }
  function wantsTweezers() { return !!(twBox && state.tweezers[state.tier] && !state.tweezersInBag); }
  function total() { return (wantsTweezers() ? cfg.totalsTw : cfg.totals)[state.tier]; }
  function allAvailable() {
    for (var i = 0; i < state.tier; i++) { var e = index[state.slots[i]]; if (!e || !e.variant.available) return false; }
    return true;
  }

  function slotHtml(i) {
    var e = index[state.slots[i]];
    if (!e) return '';
    var meta = LEN_NAME[e.variant.len] + ' · ' + LEN_MM[e.variant.len] + (e.style.colour === 'brown' ? ' · Brown' : '');
    var out = !e.variant.available;
    return '<button type="button" class="lpp-slot" data-slot="' + i + '" aria-label="Box ' + (i + 1) + ': ' + esc(e.style.name) + ', ' + esc(meta) + '. Change">' +
      '<span class="lpp-slot-n">' + (i + 1) + '</span>' +
      '<img src="' + esc(e.style.img) + '" alt="" width="44" height="44" loading="lazy">' +
      '<span><span class="lpp-slot-name">' + LOOK_NAME[e.style.look] + ' - ' + esc(e.style.name) + '</span>' +
      '<span class="lpp-slot-meta' + (out ? ' is-out' : '') + '">' + (out ? 'Sold out, please change' : esc(meta)) + '</span></span>' +
      '<span class="lpp-slot-change">Change</span></button>';
  }

  function render() {
    root.querySelectorAll('[data-tier]').forEach(function (row) {
      var on = Number(row.getAttribute('data-tier')) === state.tier;
      row.classList.toggle('is-on', on);
      row.querySelector('[data-pick-tier]').setAttribute('aria-checked', on ? 'true' : 'false');
      var box = row.querySelector('[data-slots]');
      if (!on) { box.innerHTML = ''; return; }
      var html = '<div class="lpp-slots-title"><span>' + (state.tier === 1 ? 'Your box' : 'Your ' + state.tier + ' boxes') + '</span><span>' + (state.tier === 1 ? 'Tap to change style or length' : 'Mix any styles') + '</span></div>';
      for (var i = 0; i < state.tier; i++) html += slotHtml(i);
      box.innerHTML = html;
    });

    if (twBox) {
      var free = state.tier === 3;
      twBox.checked = wantsTweezers();
      twBox.disabled = state.busy || state.tweezersInBag;
      $('lppTwTitle').textContent = free ? 'Free non-stick tweezers' : 'Add non-stick tweezers - ' + cfg.tweezers.price;
      $('lppTwNote').textContent = state.tweezersInBag ? 'You already have tweezers in your bag.'
        : free ? 'Included with 3 boxes. Untick if you already have a pair.'
        : 'You need tweezers to apply. Untick if you already have a pair.';
      var twRow = twBox.closest('.lpp-tw');
      if (twRow) { twRow.style.borderColor = free ? '' : '#c0392b'; twRow.style.background = free ? '' : '#fdf3f1'; }
      $('lppTwColourRow').hidden = !wantsTweezers();
    }

    var ok = allAvailable();
    var label = state.busy ? 'Adding to your bag' : !ok ? 'Sold out - change a box above' : 'Add to bag - ' + total();
    root.querySelectorAll('[data-add]').forEach(function (b) {
      b.disabled = state.busy || !ok;
      b.textContent = b.id === 'lppAtc' ? label : (state.busy ? 'Adding' : 'Add to bag');
    });
    $('lppStickyLabel').textContent = state.tier + (state.tier === 1 ? ' box' : ' boxes') + (wantsTweezers() ? (state.tier === 3 ? ' + free tweezers' : ' + tweezers') : '');
    $('lppStickyPrice').textContent = total();
    var tabby = $('lppTabby');
    var amount = total().match(/(\d[\d,]*\.?\d*)\s*$/);
    if (tabby && amount) tabby.textContent = 'Dhs. ' + (parseFloat(amount[1].replace(/,/g, '')) / 4).toFixed(2);
  }

  /* ---------- style picker ---------- */
  function renderList() {
    var current = index[state.slots[state.pickSlot]];
    var html = '';
    LOOKS.forEach(function (look) {
      var list = cfg.styles.filter(function (s) { return s.look === look[0] && s.colour === state.colour; });
      if (!list.length) return;
      html += '<p class="lpp-group">' + look[1] + '</p>';
      list.forEach(function (s) {
        var on = current && current.style.id === s.id;
        html += '<div class="lpp-style' + (on ? ' is-on' : '') + '"><img src="' + esc(s.img) + '" alt="" width="76" height="76" loading="lazy"><div><h3>' + esc(s.name) + '</h3><p>' + esc(s.desc) + '</p><div class="lpp-chips">';
        s.variants.forEach(function (v) {
          html += '<button type="button" class="lpp-chip' + (current && current.variant.id === v.id ? ' is-on' : '') + '" data-variant="' + v.id + '"' + (v.available ? '' : ' disabled') + '>' + LEN_NAME[v.len] + ' ' + LEN_MM[v.len] + (v.available ? '' : ' (sold out)') + '</button>';
        });
        html += '</div></div></div>';
      });
    });
    $('lppList').innerHTML = html || '<p class="lpp-group">No styles in this colour right now</p>';
    $('lppColours').querySelectorAll('[data-colour]').forEach(function (b) { b.classList.toggle('is-on', b.getAttribute('data-colour') === state.colour); });
  }
  function openSheet(slot) {
    state.pickSlot = slot;
    var e = index[state.slots[slot]];
    state.colour = e ? e.style.colour : 'black';
    $('lppSheetSub').textContent = state.tier === 1 ? 'Pick a style, then a length.' : 'Box ' + (slot + 1) + ' of ' + state.tier + '. Pick a style, then a length.';
    $('lppColours').hidden = !hasBrown;
    $('lppAllRow').hidden = state.tier === 1;
    $('lppAll').checked = false;
    renderList();
    sheet.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    sheet.querySelector('[data-close]').focus();
  }
  function closeSheet() {
    if (!sheet.classList.contains('is-open')) return;
    sheet.classList.remove('is-open');
    document.body.style.overflow = '';
    var back = root.querySelector('[data-slot="' + state.pickSlot + '"]');
    if (back) back.focus();
  }

  /* ---------- video player ---------- */
  function openPlayer(url) {
    $('lppPlayerSlot').innerHTML = '<video src="' + esc(url) + '" controls autoplay playsinline></video>';
    player.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }
  function closePlayer() {
    if (!player.classList.contains('is-open')) return;
    $('lppPlayerSlot').innerHTML = '';
    player.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  /* ---------- bag ---------- */
  function checkBag() {
    fetch(base() + 'cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (cart) {
        if (!cart) return;
        state.tweezersInBag = cart.items.some(function (it) { return it.product_id === cfg.tweezers.productId; });
        render();
      }).catch(function () {});
  }
  function add() {
    if (state.busy || !allAvailable()) return;
    if (cfg.preview) { status.textContent = 'Add to bag is switched off inside the theme editor.'; return; }
    state.busy = true; status.textContent = ''; render();
    var qty = {}, order = [];
    for (var i = 0; i < state.tier; i++) {
      var id = state.slots[i];
      if (!qty[id]) { qty[id] = 0; order.push(id); }
      qty[id]++;
    }
    var items = order.map(function (id) { return { id: id, quantity: qty[id] }; });
    if (wantsTweezers()) {
      /* Same line properties as the Essential Upsell pop-up, so the app's tweezer discount applies. */
      var funnel = state.tier === 3 && FREE_FUNNEL ? FREE_FUNNEL : ADDON_FUNNEL;
      items.push({ id: Number($('lppTwColour').value), quantity: 1, properties: { __essential_upsell_funnel_id: funnel, __essential_upsell_product_id: String(cfg.tweezers.productId) } });
    }
    fetch(base() + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      if (r.ok) { window.location.assign(cfg.cartUrl || base() + 'cart'); return; }
      return r.json().catch(function () { return {}; }).then(function (body) {
        throw new Error(typeof body.description === 'string' ? body.description : 'Some boxes could not be added.');
      });
    }).catch(function (err) {
      status.innerHTML = esc(err.message || 'We could not add your lashes.') + ' <a href="' + esc(cfg.cartUrl || '/cart') + '">Check your bag</a> before trying again.';
      state.busy = false; render();
    });
  }

  /* ---------- events ---------- */
  root.addEventListener('click', function (ev) {
    var t = ev.target;
    var el;
    if ((el = t.closest('[data-pick-tier]'))) { state.tier = Number(el.getAttribute('data-pick-tier')); status.textContent = ''; render(); return; }
    if ((el = t.closest('[data-slot]'))) { openSheet(Number(el.getAttribute('data-slot'))); return; }
    if ((el = t.closest('[data-add]'))) { add(); return; }
    if ((el = t.closest('[data-colour]'))) { state.colour = el.getAttribute('data-colour'); renderList(); return; }
    if ((el = t.closest('[data-variant]'))) {
      var id = Number(el.getAttribute('data-variant'));
      if ($('lppAll').checked) state.slots = [id, id, id]; else state.slots[state.pickSlot] = id;
      closeSheet(); render();
      var back = root.querySelector('[data-slot="' + state.pickSlot + '"]');
      if (back) back.focus();
      return;
    }
    if (t.closest('[data-close]') || t === sheet) { closeSheet(); return; }
    if ((el = t.closest('[data-clip]'))) { openPlayer(el.getAttribute('data-clip')); return; }
    if (t.closest('[data-close-player]') || t === player) { closePlayer(); return; }
    if ((el = t.closest('.lpp-thumb'))) {
      var main = $('lppMain');
      main.innerHTML = el.getAttribute('data-video')
        ? '<video src="' + esc(el.getAttribute('data-video')) + '" controls autoplay muted playsinline></video>'
        : '<img src="' + esc(el.getAttribute('data-img')) + '" alt="">';
      root.querySelectorAll('.lpp-thumb').forEach(function (b) { b.classList.toggle('is-on', b === el); });
      return;
    }
    if (t.closest('#pdpRatingBar')) { var rv = $('reviewsSection'); if (rv) rv.scrollIntoView({ behavior: 'smooth' }); }
  });
  document.addEventListener('keydown', function (ev) { if (ev.key === 'Escape') { closeSheet(); closePlayer(); } });
  if (twBox) twBox.addEventListener('change', function () { state.tweezers[state.tier] = twBox.checked; render(); });

  /* ---------- sticky bar: shows once the main button has scrolled away ---------- */
  var atc = $('lppAtc');
  if ('IntersectionObserver' in window && atc) {
    new IntersectionObserver(function (entries) {
      var e = entries[0];
      $('lppSticky').classList.toggle('is-on', !e.isIntersecting && e.boundingClientRect.top < 0);
    }, { threshold: 0 }).observe(atc);
  }

  /* ---------- how-to video: plays muted while it is on screen and its section is open ---------- */
  var how = $('lppHowtoVideo');
  if (how && 'IntersectionObserver' in window) {
    var seen = false;
    var sync = function () {
      if (seen && $('lppHowto').open) { var p = how.play(); if (p && p.catch) p.catch(function () {}); }
      else how.pause();
    };
    new IntersectionObserver(function (entries) { seen = entries[0].isIntersecting; sync(); }, { threshold: 0.4 }).observe(how);
    $('lppHowto').addEventListener('toggle', sync);
  }

  /* ---------- shipping promise. UAE time is UTC+4 all year. Cut-off 10:00, no dispatch on Sundays ---------- */
  var DAYS = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
  var MONTHS = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
  function shipping() {
    var el = $('lppShipText');
    if (!el) return;
    var uae = $('lppShip').getAttribute('data-uae') === 'true';
    var now = new Date(Date.now() + 4 * 3600 * 1000);
    var dow = now.getUTCDay();
    var mins = now.getUTCHours() * 60 + now.getUTCMinutes();
    var wait = 0;
    if (dow === 0) wait = 1;
    else if (mins >= 600) wait = dow === 6 ? 2 : 1;
    var day = new Date(now.getTime() + wait * 86400000);
    var date = DAYS[day.getUTCDay()] + ' ' + day.getUTCDate() + ' ' + MONTHS[day.getUTCMonth()];
    var verb = uae ? 'delivered' : 'shipped';
    var html, sub;
    if (wait === 0) {
      var left = 600 - mins;
      html = 'Order before <strong>10:00 AM</strong>' + (uae ? '' : ' UAE time') + ', ' + verb + ' <strong>today</strong>';
      sub = (left >= 60 ? Math.floor(left / 60) + ' h ' : '') + (left % 60) + ' min left for dispatch today.';
    } else {
      html = 'Order now, ' + verb + ' <strong>' + (wait === 1 ? 'tomorrow, ' : '') + date + '</strong>';
      sub = 'We ship every day at 11 AM' + (uae ? '' : ' UAE time') + ', except Sundays.';
    }
    el.innerHTML = html;
    $('lppShipSub').textContent = sub;
  }
  shipping();
  setInterval(shipping, 60000);

  /* ---------- Judge.me rating in the bar under the photos ---------- */
  function rating(attempt) {
    var b = document.querySelector('.jdgm-badge-holder .jdgm-prev-badge');
    var bar = $('pdpRatingBar');
    if (b && bar) {
      var avg = parseFloat(b.getAttribute('data-average-rating'));
      var n = parseInt(b.getAttribute('data-number-of-reviews'), 10);
      if (avg > 0 && n > 0) {
        $('litStarsFill').style.width = Math.min(avg / 5 * 100 - 4, 93) + '%';
        $('litRatingText').textContent = avg.toFixed(1) + ' (' + n + ' review' + (n === 1 ? '' : 's') + ')';
        bar.classList.add('on');
        return;
      }
    }
    if (attempt < 12) setTimeout(function () { rating(attempt + 1); }, 700);
  }

  render();
  checkBag();
  rating(0);
})();
